import FormattedMessage from 'I18n/components/FormattedMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { Button } from 'foundations-components/transitional/components/Button';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Box } from 'foundations-components/transitional/components/Box';
import { getPaymentLinksUrl } from 'FormsUI/lib/RouteGenerators';
import { ConfigurationPanelHeaderWrapper } from '../ConfigurationPanelHeader';
import { LeftIcon } from 'foundations-assets/icons/components/LeftIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PaymentConfigurationPanelHeader = ({
  handleDone
}) => {
  return /*#__PURE__*/_jsx(ConfigurationPanelHeaderWrapper, {
    "data-test-id": "configuration-panel-header",
    children: /*#__PURE__*/_jsxs(TFlex, {
      justify: "between",
      children: [/*#__PURE__*/_jsx(Box, {
        children: /*#__PURE__*/_jsxs(Button, {
          id: "done-button",
          onClick: handleDone,
          use: "link",
          "data-test-id": "done-button",
          children: [/*#__PURE__*/_jsx(LeftIcon, {}), /*#__PURE__*/_jsx(FormattedMessage, {
            message: 'editor.form.config.panelHeader.done'
          })]
        })
      }), /*#__PURE__*/_jsx(Box, {
        "data-test-id": "property-link",
        children: /*#__PURE__*/_jsx(Link, {
          href: getPaymentLinksUrl(),
          external: true,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: 'editor.options.payment.configPanel.paymentLink'
          })
        })
      })]
    })
  });
};
export default PaymentConfigurationPanelHeader;